/* global localStorage */
import animateScrollTo from 'animated-scroll-to'
import { connect } from 'unistore/preact'
import cx from 'classnames'

import s from './index.sass'
import gs from '../generic-sign-up.sass'
import Footer from '../../footer'
import { isMobile } from '../../../helpers/devices'
import ClubSection from '../club-section'
import SummarySection from '../summary-section'
import BoundComponent from '../../../helpers/bound-component'
import MembershipSection from '../membership-section'
import {
  addCrumb,
  clearCrumbs
} from '../../header/actions'
import {
  updateInput,
  setInputAndAddOns,
  setSuggestion,
  setExclusiveAndAddons
} from './actions'
import {
  resetSignUp
} from '../actions'
import Loader from '../../loader'
import prerendered from '../../../hoc/prerendered-content'
import {
  updateAddOns
} from '../step-wizard/actions'
import { getSuggested } from '../selectors'
import { getToken } from '../../../login'
import { route } from 'preact-router'
import { LS } from '../constants'
import { purchaseFunnelLoaded } from '../../../helpers/analytics'
import { pickProperties } from '../helpers'
import ActionButton from '../../action-button'

export const defaultScrollOptions = {
  verticalOffset: -(isMobile() ? 80 + 43 : 99 + 61),
  speed: 750
}

const CenteredLoader = ({ class: _class, className, ...rest }) => (
  <div className={cx(gs.loaderContainer, className)} {...rest}>
    <Loader showImmediately />
  </div>
)

class Membership extends BoundComponent {
  constructor (props) {
    super(props)

    // const hasParams = this.props.matches && Object.keys(this.props.matches).length > 1 // There will always be one due to membership
    const initWithClub = this.props.matches.exclusiveToClub
    const initInput = pickProperties(this.props.matches, ['club'])
    const initWithParams = Object.keys(initInput).length > 0
    const initAddOns = this.props.matches.addOns

    this.state = {
      initWithClub,
      initInput,
      initWithParams,
      initAddOns: (initAddOns || '').split(',').filter(v => v),
      initLoading: true,
      summaryIsMounted: false,
      sections: {
        club: {
          isCollapsed: !!initWithClub
        },
        summary: {
          isLoading: false,
          isCollapsed: !(initWithClub || initWithParams)
        },
        membership: {
          isCollapsed: true
        }
      }
    }

    this.bind = ['scrollTo', 'handleOnAddOn']

    this.references = {}
  }

  componentDidMount () {
    this.props.resetSignUp()
    this.props.addCrumb('Bli medlem')
    this.props.addCrumb('Gym')

    if (this.state.initWithClub) {
      this.onInitWithClub().then(() => {
        this.setState({
          initLoading: false
        })
      })
    } else if (this.state.initWithParams) {
      this.onInitWithParams().then(() => {
        this.setState({
          initLoading: false
        })
        // setTimeout(() => {
        //   const ref = this.references['summary']
        //   if (ref && ref.base) {
        //     ref.base.scrollIntoView({ behavior: 'instant' }) // client wanted a more "instant" feeling.
        //   }
        // }, 15)
      })
    } else {
      this.onInit()
        .then(() => {
          this.setState({
            initLoading: false
          })
        })
        .catch((error) => {
          this.setState({
            initLoading: false,
            error
          })
        })
    }

    purchaseFunnelLoaded()
  }

  componentWillUnmount () {
    this.props.clearCrumbs()
  }

  componentDidUpdate (_, prevState) {
    if (!prevState.summaryIsMounted && this.state.summaryIsMounted && this.state.initWithParams) {
      console.log('ready to scroll.')
      setTimeout(() => {
        const ref = this.references['summary']
        if (ref && ref.base) {
          console.log('scrolling to', ref.base.offsetTop)
          window.scrollTo(0, ref.base.offsetTop - 60)
          console.log('scrolled')
        }
      }, 150)
    }
  }

  async onInitWithClub () {
    const { membership } = this.props.matches
    await this.props.setExclusiveAndAddons(membership, this.state.initWithClub, this.state.initAddOns)
  }

  async onInitWithParams () {
    const { membership } = this.props.matches

    await this.props.setInputAndAddOns(membership, this.state.initInput, this.state.initAddOns)
  }

  async onInit () {
    const { membership } = this.props.matches

    if (!membership) throw new Error('Felaktig adress!')

    await this.props.setSuggestion(membership)
  }

  setRef (key) {
    return (element) => { this.references[key] = element }
  }

  addCrumb (input) {
    const crumb = this.props.content.guideInputs[input] && this.props.content.guideInputs[input].name
    if (crumb && !this.props.breadcrumbs.includes(crumb)) this.props.addCrumb(this.props.content.guideInputs[input].name)
  }

  toggleNextSection (next) {
    this.setState({
      sections: {
        ...this.state.sections,
        [next]: {
          isLoading: false,
          isCollapsed: false
        }
      }
    })
  }

  buildQueryString () {
    const { signUpInput, signUpAddOns } = this.props

    const truthyInput = Object.keys(signUpInput).filter(key => signUpInput[key]).reduce((prev, curr) => ({ ...prev, [curr]: signUpInput[curr] }), {})
    const params = new URLSearchParams({ membership: this.props.matches.membership, ...truthyInput, addOns: signUpAddOns.toString() })

    return `?${params.toString()}`
  }

  handleOnInput (value, currentInput, nextInput) {
    this.setState({
      sections: {
        ...this.state.sections,
        [nextInput]: {
          ...this.state.sections[nextInput],
          isLoading: true
        }
      }
    }, () => {
      this.props.updateInput(currentInput, value, this.props.membership).then(() => {
        window.history.replaceState(window.history.state, '', this.buildQueryString())
        this.addCrumb(nextInput)
        this.toggleNextSection(nextInput)
      })
    })
  }

  redirectToPayment () {
    localStorage.setItem(LS.shareUrl, window.location.href)
    route(`/bli-medlem/betalning`)
  }

  handleOnToNext (nextInput) {
    if (getToken()) { // If logged in, go directly to payment
      this.redirectToPayment()
    } else {
      this.toggleNextSection(nextInput)
      this.addCrumb(nextInput)
    }
  }

  handleOnAddOn (value) {
    this.props.updateAddOns(value).then(() => {
      window.history.replaceState(window.history.state, '', this.buildQueryString())
    })
  }

  scrollTo (key) {
    console.log('scrolling to', key)
    const preactRef = this.references[key]
    if (preactRef && preactRef.base) animateScrollTo(preactRef.base.offsetTop, defaultScrollOptions)
  }

  render ({
    signUpSuggestion,
    signUpInput,
    signUpAddOns,
    suggestion,
    content,
    membership
  }, {
    sections,
    initLoading,
    initWithClub,
    error
  }) {
    const { scrollTo, handleOnAddOn } = this.binds()

    const { guideInputs } = content

    const srcData = guideInputs && {
      ...guideInputs,
      upgrade: {
        ...guideInputs.upgrade,
        inputs: signUpSuggestion && signUpSuggestion.upgradeableTo.upgradeableMemberships
      }
    }

    return !initLoading && srcData
      ? (
        <div className={s.view}>
          <div className={s.membership}>
            <h1>Bli medlem</h1>

            {error
              ? (
                <div className={s.error}>
                  <h2>Hoppsan!</h2>
                  <p>Det verkar som adressen du angav är felaktig. Var god kontrollera adressen.</p>
                  <p>Du kan även prova våran guide så hjälper vi dig att bli medlem!</p>
                  <ActionButton label='Gå till guiden' href='/bli-medlem/guide' />
                </div>
              )
              : (
                <div>
                  <ClubSection
                    ref={this.setRef('club')}
                    isCollapsed={sections.club.isCollapsed}
                    onInput={(value) => this.handleOnInput(value, 'club', 'summary')}
                    title={srcData.club.title}
                    preselect={this.props.matches.preselect}
                    value={signUpInput.club}
                    clubs={srcData.club.inputs}
                    type={suggestion.type}
                  />

                  <div>
                    {sections.summary.isLoading && <CenteredLoader />}
                    <SummarySection
                      ref={this.setRef('summary')}
                      hideSeparator={initWithClub}
                      noPadding={initWithClub}
                      onMount={() => this.setState({ summaryIsMounted: true })}
                      isCollapsed={sections.summary.isCollapsed}
                      onExpand={() => this.scrollTo('summary')}
                      title={srcData.summary.title}
                      srcData={srcData}
                      inputs={signUpInput}
                      onEdit={scrollTo}
                      addOnsCopy={content.addOnsCopy}
                      addOnsValue={signUpAddOns}
                      handleOnAddOn={handleOnAddOn}
                      suggestion={suggestion}
                      includesTitle={srcData.summary.includesTitle}
                      includes={srcData.summary.includes}
                      onToPayment={() => this.handleOnToNext('membership')}
                      disableEdits={!!initWithClub}
                    />
                  </div>

                  <MembershipSection
                    ref={this.setRef('membership')}
                    isCollapsed={sections.membership.isCollapsed}
                    onExpand={() => this.scrollTo('membership')}
                    title={srcData.membership.title}
                    description={srcData.membership.description}
                    redirect={() => this.redirectToPayment()}
                  />
                </div>
              )}
          </div>

          <Footer />
        </div>
      )
      : <CenteredLoader className={s.initLoader} />
  }
}

export const selectors = (state) => {
  const { breadcrumbs, signUpInput, signUpAddOns, signUpSuggestion } = state
  return {
    breadcrumbs,
    signUpInput,
    signUpAddOns,
    signUpSuggestion,
    suggestion: getSuggested(state)
  }
}

export default prerendered(connect(selectors, { addCrumb, clearCrumbs, updateInput, setInputAndAddOns, updateAddOns, setSuggestion, resetSignUp, setExclusiveAndAddons })(Membership))



// WEBPACK FOOTER //
// ./components/signup-flow/step-membership/index.js